export default __webpack_public_path__ + "static/media/uploader-oneTouchVerioIQ-1.a5ba7044.png";